import { inject, Injectable, signal } from '@angular/core';
import { BaseService } from '../base/base.service';
import { environment } from '@/environments/environment.development';
import { LocalStorageService } from '../localStorage/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class ClubService {
  private baseService = inject(BaseService);
  private localStorageService = inject(LocalStorageService);
  protected url = environment;

  clubs = signal<any[]>(this.localStorageService.getClubs());

  setClubs(clubsList: any[]) {
    this.clubs.set(clubsList);
    this.localStorageService.saveClubs(clubsList);
  }

  // NOTE: Désactivé côté backend v1 (l'inscription d'un club passe par POST /membership/)
  // createClub(data: any) {
  //   return this.baseService.create(this.url.endPoint.createClub, data);
  // }

  getClubs() {
    return this.baseService.getAll(this.url.endPoint.getClubs);
  }

  updateClub(slug: string, data: any) {
    return this.baseService.update(this.url.endPoint.updateClub(slug), data);
  }

  hasAddress(clubId: number | string) {
    return this.baseService.getOne(this.url.endPoint.hasAddress(clubId));
  }

  assignByCode(clubId: number | string, code: string) {
    return this.baseService.create(this.url.endPoint.assignByCode(clubId), { code });
  }
}
